module.exports = __webpack_public_path__ + "static/media/coaching-session.35a7b532.svg";